export const QUICKBOOKS_ENDPOINT = `https://${process.env.NEXT_PUBLIC_DEV
	? 'sandbox-'
	: ''}quickbooks.api.intuit.com/v3/company`;
